
<div class="card-component details-items-body">
    <div class="main-header ng-star-inserted">{{reference}}</div>
    <div class="sections-wrapper">
      <ng-container *ngFor="let item of getItems()" [appRenderNode]="item"> </ng-container>
    </div>
  </div>
  